import {
  datadogRum,
  type RumInitConfiguration,
} from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'

interface DatadogEnvironment {
  readonly VITE_DATADOG_APPLICATION_ID?: string
  readonly VITE_DATADOG_CLIENT_TOKEN?: string
  readonly VITE_DATADOG_ENV?: string
  readonly VITE_APP_VERSION?: string
}

interface DatadogRumClient {
  init(configuration: RumInitConfiguration): void
}

export function initializeDatadogRum(
  environment: DatadogEnvironment,
  rumClient: DatadogRumClient = datadogRum,
) {
  const applicationId = environment.VITE_DATADOG_APPLICATION_ID
  const clientToken = environment.VITE_DATADOG_CLIENT_TOKEN

  if (!applicationId || !clientToken) {
    return
  }

  rumClient.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'device-config-web',
    env: environment.VITE_DATADOG_ENV,
    version: environment.VITE_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: true })],
  })
}
